function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.183.192a.656.656 0 00-.928.928l1.504 1.505H8.094a2.406 2.406 0 00-2.406 2.406v4.813c0 .561-.423 1.024-.968 1.086a2.407 2.407 0 10.003 1.317A2.406 2.406 0 007 9.844V5.03c0-.604.49-1.093 1.094-1.093h3.665l-1.504 1.504a.656.656 0 00.928.928l2.625-2.625a.656.656 0 000-.928L11.183.192z",
  fill: "#6264A7"
});

function SvgLifecyclePhaseTransitionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecyclePhaseTransitionIcon;